/** Sponsor users by org (sponsers.jsx + Team tab sponsor) — FE → API sort. */

import { sortConfigToApiParams } from "./gridSortApiParams";

export const SPONSOR_USERS_BY_ORG_USE_SERVER_SORT = true;

export const SPONSOR_USERS_BY_ORG_API_SORT_FIELD = {
  first_name: "first_name",
  last_name: "last_name",
  name: "name",
  email: "email",
  is_active: "is_active",
  title: "title",
  role: "role",
  portal_access: "portal_access",
  created_at: "created_at",
};

export function sortConfigToSponsorUsersByOrgApiParams(
  sortConfig,
  enabled = SPONSOR_USERS_BY_ORG_USE_SERVER_SORT
) {
  return sortConfigToApiParams(sortConfig, SPONSOR_USERS_BY_ORG_API_SORT_FIELD, enabled);
}
